/**
 * The reserved Heirloom sample invitation.
 *
 * `demo-heirloom` is a slug reserved on the backend (api/constants/demoEvent.mjs):
 * GET /api/events/demo-heirloom/public short-circuits before any DB lookup and
 * returns a complete, hard-coded Heirloom payload, and its RSVP submit is
 * answered with `demo: true` without writing anything. So this URL is a real,
 * fully rendered invitation that belongs to no couple and stores no reply —
 * which is what makes it safe to hand to anyone who has not paid.
 *
 * `?lang=` is honoured by the backend for this slug alone (real events ignore
 * it), so the preview opens in the visitor's current language rather than
 * making them find the toggle.
 *
 * One owner, because there are already two other copies of this string in the
 * product — app/src/lib/dashboard-utils.ts and api/constants/demoEvent.mjs —
 * and a third inside a component was one too many. Anything on this site that
 * links to the sample invitation imports from here.
 *
 * @param {"en"|"el"} [shortLang] short language code; omitted leaves the choice
 *   to the invite app's own detection.
 * @returns {string} absolute URL of the sample invitation
 */
export const buildDemoInvitationUrl = (shortLang) => {
  const base = (
    import.meta.env.VITE_INVITE_URL || "https://invite.agapae.gr"
  ).replace(/\/$/, "");
  const prefixed = base.startsWith("http") ? base : `https://${base}`;
  const query = shortLang ? `?lang=${shortLang}` : "";
  return `${prefixed}/events/demo-heirloom${query}`;
};

export default buildDemoInvitationUrl;
